import React, { useEffect, useState } from "react";

import { useGetFieldShape, useTranslation } from "utils";

import { CropFCPO, FieldDetails, FieldListField } from "models";

import { ErrorBoundary, Flex, Icon, MapStatic, Typography } from "components";

export type MissingDataDrawerHeaderProps = {
  year: number;
  crops: CropFCPO[];
  fieldIds: string[];
  fieldDetails: FieldDetails | undefined;
};
export const MissingDataDrawerHeader = ({ year, fieldDetails, crops, fieldIds }: MissingDataDrawerHeaderProps) => {
  const { t } = useTranslation("historicalPracticeDataTableView");
  const fieldId = fieldIds[0];
  const { fieldShape, fieldShapeLoading } = useGetFieldShape({ fieldId: fieldId });
  const cropNames = Array.from(new Set(crops.map((crop) => crop.cropName)));
  const fieldsCount = fieldIds.length;
  const [field, setField] = useState<FieldListField | null>(null);

  useEffect(() => {
    const field: FieldListField | null = fieldDetails
      ? {
          id: fieldDetails.id,
          name: fieldDetails.name,
          size: fieldDetails.size,
          isInRedzone: fieldDetails.isInRedzone,
          redzones: [],
          location: { lat: fieldDetails.location?.lat, lng: fieldDetails.location?.lng },
          regionId: fieldDetails.regionId,
        }
      : null;

    setField(field);
  }, [fieldDetails]);

  return (
    <Flex align="center" gap="1rem">
      <>
        {fieldsCount > 1 ? (
          <Flex align="center" justify="center" className="missing-data-drawer-header-multi-icon">
            <Icon iconName="tabler/copy" size="l" />
          </Flex>
        ) : (
          <div className="field-headline-map-container" style={{ height: "5rem", width: "5rem" }}>
            {!fieldShapeLoading && (
              <ErrorBoundary>
                {/* @ts-expect-error need to convert to tsx */}
                <MapStatic field={field} geometry={fieldShape} location={field?.location} />
              </ErrorBoundary>
            )}
          </div>
        )}
      </>
      <Flex flex="2" vertical={true}>
        <Typography variant="h5" className="margin-bottom-25">
          {t("drawer.header.fieldsSelected", { count: fieldsCount })}
        </Typography>
        <Typography variant="paragraph-s" color="grey-600">
          {t("drawer.header.year", { year })}
        </Typography>
        <Typography variant="paragraph-s" color="grey-600" className="margin-0">
          {t("drawer.header.crops", { crops: cropNames.join(", ") })}
        </Typography>
      </Flex>
    </Flex>
  );
};
